import { render } from "./FormComboArray.vue?vue&type=template&id=224befd2"
import script from "./FormComboArray.vue?vue&type=script&lang=js"
export * from "./FormComboArray.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__